import React from "react";

import { App, Button, Form, Input, InputNumber, Select } from "antd";
import { useTranslation } from "react-i18next";

import { API_URL } from "../../shared/utils/Util";
import { fetchT } from "../../shared/utils/TypedUtil";
import { CreateAnnouncementRequest, CreateAnnouncementResponse } from "../../types/api";

type NewAnnouncementFormProps = {
  restaurantId: string;
  onSuccess: () => void;
};

export const NewAnnouncementForm = (props: NewAnnouncementFormProps) => {
  const { notification } = App.useApp();
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [form] = Form.useForm();

  const handleSave = (req: CreateAnnouncementRequest) => {
    setSaveLoading(true);

    fetchT<CreateAnnouncementResponse>(
      "POST",
      `${API_URL}/v1/r/${props.restaurantId}/announcements`,
      req,
      (result: CreateAnnouncementResponse) => {
        notification.success({
          message: t("success"),
          description: t("added_new_announcement_successfully"),
        });
        form.resetFields();
        setSaveLoading(false);
        props.onSuccess();
      },
      (err: any) => {
        setSaveLoading(false);

        let description: string = "";
        try {
          description = JSON.parse(err)["message"];
        } catch (e) {
          description = t("error_occurred");
        }

        notification.error({
          message: t("error"),
          description: description,
        });
      }
    );
  };

  return (
    <Form
      form={form}
      labelCol={{ span: 10 }}
      labelAlign="left"
      wrapperCol={{ span: 16 }}
      layout="horizontal"
      colon={false}
      onFinish={handleSave}
    >
      <Form.Item
        label={t("title")}
        name="title"
        rules={[
          {
            required: true,
            message: t("title_is_required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item label={t("content")} name="content">
        <Input.TextArea maxLength={4096} />
      </Form.Item>
      <Form.Item
        label={t("type")}
        name="annoucement_type"
        rules={[
          {
            required: true,
            message: t("announcement_type_is_required"),
          },
        ]}
      >
        <Select
          options={[
            { value: "INFO", label: t("info") },
            { value: "WARNING", label: t("warning") },
          ]}
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" block htmlType="submit" loading={saveLoading} disabled={saveLoading}>
          {t("save")}
        </Button>
      </Form.Item>
    </Form>
  );
};
